import { makeHttpParamExtractor } from "@lg-plus/landing-modules/http-param-extractor";
import { getRuntimeConfig } from "../runtime-config/runtime-config.js";
export const handleStaticPageRequest = async ({ req, }) => {
    const headers = makeHttpParamExtractor(req.headers);
    const domain = (headers("host") || "").split(":", 2)[0];
    return {
        props: {
            config: getRuntimeConfig(),
            traits: { domain },
        },
    };
};
